<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">Reply to service query </h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div>
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Notes</mat-label>
          <textarea [(ngModel)]="reply" matInput></textarea>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    
      
    <mat-dialog-actions align="end">
        <button
          mat-button
          mat-dialog-close
      
        >
          Cancel
        </button>
        <button
          
          mat-flat-button
          color="accent"
          (click)="onPost()"
          
        >
          Confirm
        </button>
    
      </mat-dialog-actions>